import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import StateChart from './StateChart';
import { Box, useTheme } from '@mui/material';
import { tokens } from '../../theme';
import { useSelector } from 'react-redux';
import BarChart from '../BarCharts';







const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const MapDialog = props => {
     // eslint-disable-next-line
    const [contentD, setContentD] = useState("");

    // const [DTName, setDTName] = useState("");
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isCollapsed = useSelector(state => state.openCloseReducer);
    const projectData = useSelector(state => state.projectReducer);
    const stateProjects = projectData.filter(project => project.state === props.StateName)

    const mode=theme.palette.mode;


    return (
        <Dialog
            style={{ left: `${isCollapsed ? "80px" : "270px"}`, width: `${isCollapsed ? "95%" : "83%"}` }}
            fullScreen
            TransitionComponent={Transition}
            open={props.show}
            onClose={props.closeModal}
        >
            <AppBar style={{ left: `${isCollapsed ? "80px" : "270px"}`, width: `${isCollapsed ? "95%" : "83%"}`, 
            backgroundColor: `${mode !== "dark" ? "#fcfcfc" :colors.primary[500] }`, color: colors.grey[100] }} >
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={props.closeModal} aria-label="close">
                        <CloseIcon />
                    </IconButton>


                    <Typography variant="h6" >

                        {props.StateName}
                    </Typography>

                </Toolbar>
            </AppBar>
            <CssBaseline />
            <Box
                display="grid"
                gridTemplateColumns="repeat(2, 1fr)"
                gridTemplateRows="1fr"
                sx={{
                    height: '100%',
                    backgroundColor: `${mode !== "dark" ? "#fcfcfc" : colors.primary[500]}`                }}>
                <Box gridArea="1/1/2/2" ><Container maxWidth="sm" style={{ margin: "0px", height: "100%", display: "flex", justifyContent: "flex-start", alignItems: "centre" }}>
                    <StateChart setTooltipContent={setContentD} /* setDistrictName={setDTName} */ selectedState={props.StateName} style={{ border: '1px solid #ddd' }} />
                </Container></Box>

                <Box marginRight="1rem"
                marginTop=" 64px"
gridArea="1/2/2/3" display="flex" justifyContent="center" alignItems="center" flexDirection="column">

                    <Box
                        height="40vh"
                        width="100%"
                        backgroundColor={colors.primary[400]}
                        overflow="auto"
                    >
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            borderBottom={`4px solid ${colors.primary[500]}`}
                            colors={colors.grey[100]}
                            p="15px"
                        >
                            <Typography color={colors.grey[100]} variant="h5" fontWeight="600">
                                {`Projects In ${props.StateName}`}
                            </Typography>
                            <Typography color={colors.grey[100]} variant="h5" fontWeight="600">
                                {`Total: ${stateProjects.length}`}
                            </Typography>

                        </Box >
                        {stateProjects.length !== 0 ? stateProjects.map((project, i) => (
                            <Box
                                key={`${project.id}-${i}`}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                borderBottom={`4px solid ${colors.primary[500]}`}
                                p="15px"
                            >
                                <Box width="40%" display="flex">
                                     <Typography
                                color={colors.greenAccent[500]}
                                variant="h5"
                                fontWeight="600"
                            >
                                    {`${i+1}.`}
                                </Typography>
                                <Box>
                                    <Typography
                                        color={colors.greenAccent[500]}
                                        variant="h5"
                                        fontWeight="600"
                                    >
                                        {project.client_name}
                                    </Typography>
                                    <Typography color={colors.grey[100]}>
                                        {project.cp_name}
                                    </Typography>
                                </Box>
                                </Box>
                               
                                <Box width="20%" color={colors.grey[100]}>{project.capex_opex}</Box>
                                <Box width="20%" color={colors.grey[100]}>{project.status}</Box>

                                <Box
                                width="20%"
                                display="flex"
                                justifyContent="center"
                                    backgroundColor={project.dc_capacity_mwp === "" ? colors.redAccent[500] : colors.greenAccent[500]}
                                    p="5px 10px"
                                    borderRadius="4px"
                                >
                                    {project.dc_capacity_mwp === "" ? "undefined" : `${project.dc_capacity_mwp} MWp`}
                                </Box>
                            </Box>
                        )) :
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                width="100%"
                                height="80%">
                                <Typography
                                    color={colors.redAccent[500]}
                                    variant="h5"
                                    fontWeight="600"
                                >
                                    No Projects to Display
                                </Typography>
                            </Box>
                        }
                    </Box>
                    <Box 
                     height="45vh"
                        width="100%"
                        marginTop="1rem"
                        backgroundColor={colors.primary[400]}
                      >
                            <BarChart isDashboard={true} />
                    </Box>
                </Box>
            </Box>
        </Dialog>
    )
};

export default MapDialog;
